import { render, staticRenderFns } from "./ChatterDrawerHeader.vue?vue&type=template&id=8dd6580e&scoped=true"
import script from "./ChatterDrawerHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatterDrawerHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChatterDrawerHeader.vue?vue&type=style&index=0&id=8dd6580e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd6580e",
  null
  
)

export default component.exports